import * as React from "react";
const SvgFiRrEnvelopes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 1H9C6.24 1 4 3.24 4 6v8c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V6c0-2.76-2.24-5-5-5M9 3h10c.89 0 1.69.39 2.24 1l-5.12 5.12a3 3 0 0 1-4.24 0L6.76 4C7.31 3.38 8.11 3 9 3m10 14H9c-1.65 0-3-1.35-3-3V6.07l4.46 4.46a5.022 5.022 0 0 0 7.08 0L22 6.07V14c0 1.65-1.35 3-3 3m0 5c0 .55-.45 1-1 1H5c-2.76 0-5-2.24-5-5V7c0-.55.45-1 1-1s1 .45 1 1v11c0 1.65 1.35 3 3 3h13c.55 0 1 .45 1 1"
    />
  </svg>
);
export default SvgFiRrEnvelopes;
